import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const EnhancedTextMatcher: FieldMatcher = {
  name: 'enhancedText',
  displayName: 'Text with Operators',
  hasEditor: true,
  options: {
    chipFormatter: ((value: { operator: string; value: string }) => {
      if (typeof value === 'string') return value;
      const operatorDisplay: Record<string, string> = {
        '=': '=',
        '>': '>',
        '<': '<',
        '>=': '≥',
        '<=': '≤',
        startsWith: 'starts with',
        contains: 'contains',
      };
      return `${operatorDisplay[value.operator] || value.operator} ${value.value}`;
    }) as unknown as (arg0: string) => string,
  },
  validators: [],
};